import apiInstance from "../api";
import endPoints from "../endpoints";

export const getBalanceSheet = (payload) => {
  return apiInstance().post(`${endPoints.rkaas.getBalanceSheet}`, payload);
};

export const getTrailBalance = (payload) => {
  return apiInstance().post(`${endPoints.rkaas.getTrailBalance}`, payload);
};

export const getLedgers = (payload) => {
  return apiInstance().post(`${endPoints.rkaas.getLedgers}`, payload);
};
